// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2TAPb","unreadBadge":"styles_unreadBadge__1tjuB","modalContent":"styles_modalContent__JheWK","modal":"styles_modal__3Qo8x"};